import { ApiNotFoundComponentModule } from './../../_component/api-not-found/api-not-found.component.module';
import { BreadcrumbComponentModule } from './../../_component/breadcrumb/breadcrumb.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { EditUserPageRoutingModule } from "./edit-user-routing.module";

import { EditUserPage } from "./edit-user.page";
import { TranslateModule } from "@ngx-translate/core";
import { UploadAttachmentModule } from "../../_component/upload-attachment/upload-attachment.module";
import { HeaderModule } from "src/app/_component/header/header.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { PaginationClientSideModule } from "src/app/app/_component/pagination-client-side/pagination-client-side.module";
import { SelectButtonsModule } from "src/app/app/_component/select-buttons/select-buttons.module";
import { AddUserDepartmentPageModule } from "../add-user-department/add-user-department.module";
import { CardComponentModule } from "../../_component/_structural/card/card.module";
import { InputsModule } from 'src/app/_component/inputs/inputs.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    EditUserPageRoutingModule,
    UploadAttachmentModule,
    HeaderModule,
    SharedDirectivesModule,
    LoadingStiModule,
    SelectDropdownModule,
    PaginationClientSideModule,
    SelectButtonsModule,
    AddUserDepartmentPageModule,
    CardComponentModule,
    BreadcrumbComponentModule,
    ApiNotFoundComponentModule,
    InputsModule,
  ],
  declarations: [EditUserPage],
})
export class EditUserPageModule {}
